import React from "react"
import PropTypes from "prop-types"
import {observer} from "mobx-react"
import SortieStore from "./SortieStore"
import { HashRouter as Router, Route, Link } from "react-router-dom";
import {Redirect } from "react-router-dom";
import Dashboard from "./Sortie/dashboard"
import ExpertiseSortie from "./Sortie/ExpertiseSortie"
import SigneSortie from "./Signatures/SigneSortie"
import Gestion from "./Gestion/Gestion"
import Compteurs from "./Compteurs/Compteurs"
import 'moment/locale/fr';
@observer
class Routeur extends React.Component {
  constructor(props) {
    super(props);
    SortieStore.bien = props.bien
    SortieStore.ordremission = props.ordremission
    SortieStore.entree = props.entree
    SortieStore.rdv = props.rdv
    this.redirects = this.redirects.bind(this)
    let redirect = ""
    this.state= {
      redirect: redirect
    }

  }
  redirects(){
    if(this.state.redirect.length >1){
      return(<Redirect to={this.state.redirect} />)
    }else{
      return(<div></div>)
    }
  }


  render () {
    if(SortieStore.loaded){
      return (
        <React.Fragment>
          <div className="row">
            {SortieStore.showPDF ? (
              <div className="col s5">
                  <iframe style={styles.iframe} src={this.props.pdfentree} frameBorder="0"></iframe>
              </div>
            ) : (<div></div>)}

            <div className={"col "+(SortieStore.showPDF ? "s7" : "s12")}>
               <Router>
                <div>
                <div className="row">
                  <div className="col s2"><Link to="/"> Dashboard</Link></div>
                  <div className="col s2"><Link to="/compteurs"> compteurs</Link></div>
                  <div className="col s2"><Link to="/signatures"> Signatures</Link></div>
                  <div className="col s2"><Link to="/gestion"> Gestion</Link></div>
                </div>
                  <Route path="/" exact component={Dashboard} />
                  <Route path="/expertise/piece/:pieceid/:title" exact component={ExpertiseSortie} />
                  <Route path="/signatures" exact component={SigneSortie} />
                  <Route path="/compteurs" exact component={Compteurs} />
                  <Route path="/gestion" exact component={Gestion} />

                </div>
              {this.redirects()}
              </Router>
            </div>
          </div>
        </React.Fragment>
      );
    }else{
      return(
        <React.Fragment>
        <p>Chargement en cours</p>
        </React.Fragment>
        )
    }
  }
}
const styles = {
  iframe: {
    width: "100%",
    minHeight: "150vh"
  }
}

export default Routeur
